<template>
    <v-container fill-height fluid>
      <v-layout justify-center align-center>
        
        <v-flex xs12>
          <material-card class="card-tabs" color="green">
  
            <v-flex slot="header">
              <v-tabs v-model="tabs" color="transparent" slider-color="white">
                <v-tab class="mr-3">资金明细</v-tab>
              </v-tabs>
            </v-flex>
  
            <v-tabs-items v-model="tabs">
              <v-tab-item >
                <order-list :load="true" />
              </v-tab-item>
            </v-tabs-items>
  
          </material-card>
        </v-flex>
      </v-layout>
    </v-container>
  </template>
  <script>
  import orderList from './hisList'
  export default {
    components:{
      orderList
    },
    data() {
      return {
        tabs: 0,
        list: {
          0: false,
          
        }
      };
    },
    mounted(){
    },
    methods: {
      complete(index) {
        this.list[index] = !this.list[index];
      }
    }
  };
  </script>